import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import Ellipse from '@ey/canvascoreservices/Ellipse';
import { labels } from '../../../util/uiconstants';
import UserSearch from '../../Common/Search/UserSearch';
import Loader from '../../Common/Loaders/loadingindicator';
import Toast from '../../Common/Toast/Toast';
import TicketField from '../../Admin/common/ticketfield';
import { validateTicketNumber } from '../../Admin/common/util';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {MotifIcon} from '@ey-xd/motif-react';
import {IconoirXmarkCircle} from '@ey-xd/motif-icon';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import EllipsesControl from '../EllipsesControl/EllipsesControl';

function AddUser(props) {
	const dispatch = useDispatch();

	const [refreshChildCompKey, setRefreshChildCompKey] = useState(0);
	const [showUserSeachValidations, setShowUserSearchValidations] = useState(0);
	const [isClearSearchText, setIsClearSearchText] = useState(true);
	const [isMultipleSearchUserAllowed, { }] = useState(true);
	const [isSearchDisable, setIsSearchDisable] = useState(false);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [addUserErrorMessage, setAddUserErrorMessage] = useState([]);
	const [currentRole, setCurrentRole] = useState();
	const [showRolesError, setShowRolesError] = useState(false);
	const [engagementRolesOptions, setEngagementRolesOptions] = useState([]);
	const showRolesDropDown = props?.showRolesDropDown ? true : false;
	const [ticketNumber, setTicketNumber] = useState('');
	const [isSubmitClicked, setIsSubmitClicked] = useState(false);

	useEffect(() => {
		if (props?.engagementRoles?.length > 0) {
			let options = [];
			props?.engagementRoles.forEach((role) => {
				options.push({
					value: role.roleId,
					label: role.roleName
				});
			});
			setEngagementRolesOptions(options);
		}
	}, []);

	const emailChecker = (email) => {
		if (email.includes("'")) {
			email = email.replaceAll("'", "''");
		}
		return email;
	};

	//Send to textbox change event
	const onUserSelectionChange = (user) => {
		var tempSentToItems = selectedUsers;
		let userItem = user && user.allProps ? user.allProps : null;
		if (userItem) {
			let email = emailChecker(userItem.email);
			let userSelectedFilter = tempSentToItems.filter(
				(ee) =>
					ee.emailAddress.trim().toLowerCase() == email.trim().toLowerCase()
			);
			if (userSelectedFilter.length === 0) {
				tempSentToItems.push({
					id: userItem.objectId,
					displayName: userItem.displayName,
					emailAddress: email,
					firstName: userItem.firstName,
					lastName: userItem.lastName
				});
				if (showRolesDropDown) {
					tempSentToItems[tempSentToItems.length - 1]['role'] = {};
					setShowRolesError(false);
				}
			}
			if (!isMultipleSearchUserAllowed) {
				setIsSearchDisable(true);
			}
			//clear user search textbox
			setIsClearSearchText(true);
		}
		setSelectedUsers(tempSentToItems);
		setRefreshChildCompKey((prevState) => prevState + 1);
		setIsSubmitClicked(false);
	};

	//Send to textbox clear event
	const onUserClear = () => {
		if (!isMultipleSearchUserAllowed) {
			if (!selectedUsers) setIsSearchDisable(true);
		}
	};

	const removeSelection = (user) => {
		var updatedSelection = selectedUsers.filter((usr) => usr.id !== user.id);
		setSelectedUsers(updatedSelection);
	};

	useEffect(() => {
		setAddUserErrorMessage(props?.addUserErrorMessage);
	}, [props?.addUserErrorMessage]);

	const closeToast = (index) => {
		setAddUserErrorMessage([
			...addUserErrorMessage.slice(0, index),
			...addUserErrorMessage.slice(index + 1, addUserErrorMessage.length)
		]);
	};

	useEffect(() => {
		setCurrentRole();
	}, [currentRole]);

	const onSelectRole = (role, index) => {
		let users = selectedUsers;
		for (let roleObj of engagementRolesOptions) {
			if (roleObj.value == role) {
				users[index].role = roleObj;
			}
		}
		setSelectedUsers(users);
		setCurrentRole(role);
	};

	const saveUsers = () => {
		if (validateTicketNumber(ticketNumber)) {
			if (showRolesDropDown) {
				for (let user of selectedUsers) {
					if (user.role === undefined) {
						setShowRolesError(true);
						return;
					}
				}
			}
			props.onSaveUsersClick(selectedUsers, ticketNumber.trim());
		}
		else {
			setIsSubmitClicked(true);
		}
	};

	function handlerOnTicketEntered(e) {
		setTicketNumber(e.target.value);
	}

	return (
		<AddUserWrapper
			className={'adduser ' + (showRolesDropDown ? 'role' : 'withoutrole')}
		>
			<section
				className="toastMessage"
				style={{
					display:
						addUserErrorMessage && addUserErrorMessage?.length > 0
							? 'block'
							: 'none'
				}}
			>
				{addUserErrorMessage?.map((errorMessage, index) => (
					<Toast
						variant="error"
						key={index}
						onClose={() => {
							closeToast(index);
						}}
					>
						{errorMessage}
					</Toast>
				))}
			</section>
			{props?.addUserLoading ? (
				<Loader show fullscreen view="blockView" styleName="loadingstyle" />
			) : (
				<section>
					<section className="userSearch customScrollbar">
						<section className="wrapper">
							<section className="headerText motif-body1-default-light">{props.addUserDescription}</section>
							<section className="adduserlist">
								<UserSearch
									key={refreshChildCompKey}
									showValidations={showUserSeachValidations}
									onUserClear={onUserClear}
									onUserSelectionChange={onUserSelectionChange}
									lookupType={props.userLookupType}
									enableClearText={isClearSearchText}
									enableUserSearch={isSearchDisable}
									isHideClearAllIconButton={true}
								/>
								{selectedUsers?.length > 0 ? (
									<>
										<section className="result">
											<section className='usedAdded motif-body1-default-regular'>{`${labels.usersToBeAdded} (${selectedUsers.length})`}</section>
											<section className={'userlistrecord'}>
												{selectedUsers.map((user, index) => {
													return (
														<ul
															key={'selecteduser' + index}
															className="userlist"
														>
															<li>
																<span className="nameemail motif-body1-default-light">
																	<Ellipse
																		content={
																			user.displayName +
																			' ' +
																			'(' +
																			user.emailAddress +
																			')'
																		}
																		tooltip={
																			user.displayName +
																			' ' +
																			'(' +
																			user.emailAddress +
																			')'
																		}
																		displayId={''}
																		noOfLines={1}
																		ellipsisClass=""
																	/>
																</span>
																{showRolesDropDown && (
																	<span className="role">
																		<MotifFormField>
																			<MotifLabel
																				id="engagementRoles-label"
																				position="in"
																			>
																				{labels.engagementRoles}
																			</MotifLabel>
																			<MotifSelect
																				ariaLabelledBy="select-role"
																				labelPosition="in"
																				visibleOptions={5}
																				onChange={(role) => onSelectRole(role, index)}
																				value={
																					user.role.value === undefined
																					? ''
																					: user.role.value.toString()
																				}
																			>
																				{engagementRolesOptions &&
																					engagementRolesOptions?.map(
																						(item) => (
																							<MotifOption
																								key={item.value}
																								value={item.value.toString()}
																								label={item.label}
																							>
																								<EllipsesControl content={item.label} tooltip={item.label} noOfLines={1} />
																							</MotifOption>
																						)
																					)}
																			</MotifSelect>
																		</MotifFormField>
																	</span>
																)}
																<MotifIcon
																	className="clearall"
																	iconFunction={IconoirXmarkCircle}
																	title={labels.clearAllValues}
																	size={24}
																	onClick={() => {
																		removeSelection(user);
																	}}
																/>
															</li>
														</ul>
													);
												})}
											</section>
										</section>
									</>
								) : null}
								<TicketField
									ticketNumber={ticketNumber}
									onTicketChanged={handlerOnTicketEntered}
									showValidation={isSubmitClicked}
								/>
							</section>
						</section>
					</section>

					<section className="modal-footer">
						<MotifButton
							variant="ghost"
							size='medium'
							onClick={() => {
								props.onNewUserModalClose(false);
							}}
						>
							{labels.cancel}
						</MotifButton>
						<MotifButton
							variant="primary"
							size='medium'
							disabled={(selectedUsers.length <= 0 || ticketNumber.trim().length <= 0) ? true : false}
							onClick={saveUsers}
						>
							{labels.add}
						</MotifButton>
					</section>
				</section>
			)}
		</AddUserWrapper>
	);
}

const AddUserWrapper = styled.section`
	.toastMessage {
		position: absolute;
		width: 100%;
		padding: 0 var(--spacing-x-large);
	}	
	&.withoutrole {
		.nameemail {
			width: 90% !important;
			display: inline-grid;
		}

		.userlistrecord {
			.usedAdded {
				padding-bottom: var(--spacing-large);
			}
			.userlist {
				padding: 0 !important;
				margin: 0 !important;
			}
		}
	}

	&.role {
		.nameemail {
			line-height: var(--px-50);
		}
	}

	.motif-loader {
		height: var(--px-485) !important;
	}

	.userSearch {
		display: flex;
		width: 100%;
		padding: var(--spacing-x-large);
		padding-bottom: 0;
		height: calc(100vh - var(--px-194));
		.adduserlist {
			width: 100%;
			display: block;
			.nameandemail {
				display: inline-grid;
			}

			.clearall {
				margin-left: var(--spacing-large);
				svg {
					vertical-align: middle;
				}
			}
		}

		.wrapper {
			display: inline-block;
			width: 100%;

			.headerText {
				padding-bottom: var(--spacing-x-large);
			}
			//ticketstart
			.ticketdetail {
				padding-bottom: var(--spacing-x-large);
				.description {
					padding: var(--spacing-x-large) 0 var(--spacing-small);
				}
				.motif-form-field {
					width: var(--px-400);
				}
			}
			//ticketend

			.result {
				width: 100%;
				display: inline-block;
				padding-top: var(--spacing-x-large);

				.userlist {
					width: 100%;
					display: flex;
					border-bottom: var(--px-1) solid var(--neutrals-200);
					padding: 0;
					margin: 0;
				}

				li {
					width: 100%;
					display: block;
					list-style-type: none;
					margin: 0;
					padding: var(--spacing-small);

					.nameemail {
						width: 66%;
						display: inline-block;

						.ellipses {
							width: 95%;
						}
					}

					.role {
						width: 26%;
						display: inline-block;
						vertical-align: middle;
						position: relative;

						.motif-option {
							font-size: var(--px-14);
						}

						.show {
							font-size: var(--px-12);
							color: var(--red-600);
							display: inline !important;
							position: absolute;
							left: calc(var(--px-20) * -1);
							top: var(--px-6);
							svg {
								width: var(--px-15);
								height: var(--px-15);
								margin-right: var(--px-2);
								vertical-align: text-bottom;
								fill: var(--red-600);
							}
						}
					}

					.remove {
						padding: 0 var(--px-15);
						text-align: right;
						display: inline-block;
						line-height: var(--px-40);
						width: 8%;
						svg {
							cursor: pointer;
							vertical-align: middle;
						}
					}
				}
			}
		}

		.user-selectbox .select-group {
			width: 100%;
		}
	}
	.modal-footer {
		display: inline-flex;
		width: 100%;
		padding: var(--spacing-x-large);
		justify-content: end;
		button {
			margin-left: var(--px-12);
		}
	}
`;

export default AddUser;
